import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "../components/button";
import { Input } from "../components/input";
import { Message } from "../components/message";
import { login } from "../services/auth";
import { useAuthStore } from "../stores/auth";
import { useLocale } from "../stores/locale";

export function Login() {
  const navigate = useNavigate();
  const authStore = useAuthStore();
  const t = useLocale((state) => state.locale);

  const [authError, setAuthError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const isValid = email.length > 0 && password.length > 0;

  return (
    <div className="mt-10 mx-auto lg:w-8/12 xl:w-6/12">
      <h1 className="text-3xl">{t.login.title}</h1>
      <form
        onSubmit={(e) => {
          (async () => {
            setIsLoading(true);
            e.preventDefault();
            try {
              await login(email, password);
              authStore.setIsAuth(true);
              navigate("/");
            } catch (error) {
              setAuthError(true);
            } finally {
              setIsLoading(false);
            }
          })();
        }}
      >
        <div className="my-2">
          <label htmlFor="email">{t.login.email}</label>
          <Input
            className="w-full"
            disabled={isLoading}
            hasError={authError}
            id="email"
            size="lg"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>
        <div className="mt-5">
          <label htmlFor="password">{t.login.password}</label>
          <Input
            className="w-full"
            disabled={isLoading}
            hasError={authError}
            id="password"
            size="lg"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>
        <div className="mt-5 flex justify-between">
          <div className="grow">
            {authError && (
              <Message className="w-full" severity="error">
                {t.login.error}
              </Message>
            )}
          </div>
          <div className="min-w-32 flex justify-end">
            <Button
              disabled={!isValid}
              loading={isLoading}
              size="lg"
              type="submit"
            >
              {t.login.submit}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
